import {
    getApiEndpoint,
    postApiEndpoint,
    postApiEndpointUnprotected,
    getLocalAuthenticationSession,
    patchApiEndpoint,
    setLocalAuthenticationSession,
    updateLocalAuthenticationSession,
    deleteLocalAuthenticationSession,
} from "@/services/base";

const clientId = process.env.VUE_APP_AUTH2_CLIENT_ID;
const clientSecret = process.env.VUE_APP_AUTH2_CLIENT_SECRET;

function getAuthenticationFormDataBasics() {
    let loginData = new FormData();
    loginData.append("client_id", clientId);
    loginData.append("client_secret", clientSecret);
    return loginData;
}

export function postLoginQuery(username, password) {
    let loginData = getAuthenticationFormDataBasics();
    loginData.append("grant_type", "password");
    loginData.append("username", username);
    loginData.append("password", password);
    return postApiEndpointUnprotected("oauth/token/", loginData);
}

export async function postRefreshTokenQuery(refreshToken) {
    let refreshTokenData = getAuthenticationFormDataBasics();
    refreshTokenData.append("grant_type", "refresh_token");
    refreshTokenData.append("refresh_token", refreshToken);
    return await postApiEndpointUnprotected("oauth/token/", refreshTokenData);
}

export function postLogoutQuery() {
    let localAuthenticationSession = getLocalAuthenticationSession();

    if (!localAuthenticationSession.access_token) return Promise.resolve();

    let logoutData = getAuthenticationFormDataBasics();
    logoutData.append("token", localAuthenticationSession.access_token);
    let request1 = postApiEndpoint("oauth/revoke_token/", logoutData);

    let logoutData2 = getAuthenticationFormDataBasics();
    logoutData2.append("token", localAuthenticationSession.refresh_token);
    let request2 = postApiEndpoint("oauth/revoke_token/", logoutData2); // Same oauth2 endpoint

    return Promise.all([request1, request2]); // No special error handling here
}

export function getAccountQuery() {
    //const headers = {Authorization: `Bearer ${access_token ? access_token : getAuthSession().access_token}`};
    return getApiEndpoint("api/account/");
}

export function patchProfileQuery(data) {
    return patchApiEndpoint("api/account/profile/", data);
}

/* DELAYED FOR NOW
// DIRTY global object for now...
var currentAccountObject = undefined ;

export function setCurrentAccountObject(newValue) {
    currentAccountObject = newValue;
}

export function getCurrentAccountObject() {
    return currentAccountObject;
}*/

export async function isAuthenticated() {
    const authSession = getLocalAuthenticationSession();
    if (authSession["access_token"]) {
        const getExpiration = authSession["expiration_date"];
        const dateNow = new Date();
        if (dateNow < new Date(getExpiration)) {
            return true;
        } else {
            try {
                const refreshData = await postRefreshTokenQuery(
                    authSession["refresh_token"]
                );
                updateLocalAuthenticationSession(refreshData.data);
                return true;
            } catch (err) {
                // See https://axios-http.com/docs/handling_errors
                if (err.response && err.response.status == 400)
                    deleteLocalAuthenticationSession(); // Must be corrupted
                return false;
            }
        }
    }
    return false;
}

export function login(username, password) {
    return postLoginQuery(username, password).then((res) => {
        setLocalAuthenticationSession(res.data);
        return res;
    });
}

export function logout() {
    deleteLocalAuthenticationSession();
    return postLogoutQuery();
}
